/* Brie beta cart UX — theme-side guard, NOT Shopify checkout validation. */
(function () {
  'use strict';
  const MIN_WHOLESALE = 25;
  const minForRow = row => row && row.dataset.brieFormat === 'wholesale-lot' ? 1 : MIN_WHOLESALE;
  function notice(message) {
    let node = document.getElementById('brie-beta-cart-notice');
    if (!node) {
      node = document.createElement('p');
      node.id = 'brie-beta-cart-notice';
      node.setAttribute('role', 'alert');
      node.style.cssText = 'padding:12px 16px;margin:12px auto;max-width:1100px;background:#fff2f2;border:1px solid #d7aaa6;color:#842b28;font-size:14px;line-height:1.5;border-radius:4px;';
      const anchor = document.querySelector('#main-cart-items, #CartDrawer-CartItems, cart-items, cart-drawer');
      if (anchor) anchor.parentNode.insertBefore(node, anchor);
      else document.body.appendChild(node);
    }
    node.textContent = message;
  }
  function decorate() {
    document.querySelectorAll('tr[data-brie-format]').forEach(row => {
      const input = row.querySelector('input.quantity__input');
      if (!input) return;
      const qty = parseInt(input.value,10) || 0;
      const mystery = (row.dataset.brieFormat === 'mystery' || row.dataset.brieFormat === 'mystery-box-total');
      const expected = Number(row.dataset.brieExpected) || 0;
      if (mystery) {
        input.readOnly = true;
        if (expected > 0) input.min = expected;
        row.querySelectorAll('button[name="minus"], button[name="plus"]').forEach(b => { if (!b.disabled) b.disabled = true; });
      } else {
        input.min = minForRow(row);
        const minus = row.querySelector('button[name="minus"]');
        if (minus) minus.disabled = qty <= minForRow(row);
      }
    });
  }
  function rowFor(target) { return target && target.closest ? target.closest('tr[data-brie-format]') : null; }
  function invalid() {
    for (const row of document.querySelectorAll('tr[data-brie-format]')) {
      const input = row.querySelector('input.quantity__input');
      if (!input) continue;
      const n = parseInt(input.value,10);
      if (row.dataset.brieFormat === 'mystery' || row.dataset.brieFormat === 'mystery-box-total') {
        if (!row.dataset.brieExpected || n !== Number(row.dataset.brieExpected)) return 'A Mystery Box quantity was changed. Remove that box and use its builder to add it again.';
      } else if (n < minForRow(row)) return row.dataset.brieFormat === 'wholesale-lot' ? 'Select at least one complete wholesale lot.' : 'Wholesale lots have a 25-piece minimum per product.';
    }
    return '';
  }
  document.addEventListener('click', function(e) {
    const button = e.target.closest && e.target.closest('button[name="minus"],button[name="plus"]');
    if (button) {
      const row = rowFor(button);
      const input = row && row.querySelector('input.quantity__input');
      if (row && input) {
        if (row.dataset.brieFormat === 'mystery' || row.dataset.brieFormat === 'mystery-box-total' || (button.name === 'minus' && Number(input.value) <= minForRow(row))) {
          e.preventDefault(); e.stopImmediatePropagation();
          notice((row.dataset.brieFormat === 'mystery' || row.dataset.brieFormat === 'mystery-box-total') ? 'To change a Mystery Box, remove it and choose a different size in the box builder.' : 'Use Remove to delete the entire lot, or select another lot size on the product page.');
          return;
        }
      }
    }
    const checkout = e.target.closest && e.target.closest('button[name="checkout"],[name="checkout"],a[href*="/checkout"]');
    if (checkout) { const problem = invalid(); if (problem) { e.preventDefault(); e.stopImmediatePropagation(); notice(problem); } }
  }, true);
  document.addEventListener('change', function(e) {
    const input=e.target;
    if (!input.matches || !input.matches('tr[data-brie-format] input.quantity__input')) return;
    const row=rowFor(input), n=parseInt(input.value,10), mystery=(row.dataset.brieFormat==='mystery' || row.dataset.brieFormat==='mystery-box-total');
    if (mystery || !Number.isInteger(n) || n < minForRow(row)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      if (mystery) { input.value=row.dataset.brieExpected || input.defaultValue; notice('Mystery Box quantities are chosen in the box builder.'); }
      else { input.value=minForRow(row); notice(row.dataset.brieFormat === 'wholesale-lot' ? 'Choose at least one complete lot.' : 'Wholesale requires at least 25 pieces per lot.'); }
      return;
    }
    decorate();
  }, true);
  let queued=false;
  function schedule(){ if(queued)return; queued=true; requestAnimationFrame(()=>{ queued=false; decorate(); }); }
  document.addEventListener('DOMContentLoaded',function(){decorate(); if(window.MutationObserver){ new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true}); } });
})();